import { ChangeDetectorRef, Component, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-dialog-component',
  imports: [CommonModule, MatDialogModule],
  templateUrl: './confirm-dialog-component.html',
  styleUrl: './confirm-dialog-component.scss',
})
export class ConfirmDialogComponent implements OnInit
{
  private dialogHandle = inject(MatDialogRef<ConfirmDialogComponent>);
  private cdr = inject(ChangeDetectorRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData)
  {

  }

  ngOnInit(): void
  {
    this.cdr.detectChanges();
  }

  onConfirm()
  {
    this.dialogHandle.close(true);
  }

  onCancel()
  {
    this.dialogHandle.close(false);
  }
}

export interface ConfirmDialogData
{
  title?: string;
  subtitle?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  severity?: 'warning' | 'danger' | 'info';
}
